'use strict';

customerZone.run(['$rootScope', '$route', 'utils', 'Session', '$log', 'BudskapService',
    function ($rootScope, $route, utils, Session, $log, BudskapService) {

        BudskapService.displayGeneralNotifications();

        if (!window.enableNgRouting) return;

        $rootScope.$on('$routeChangeSuccess', function(event, toRoute, fromRoute){
            if (toRoute.notificationContexts) {
                BudskapService.displayNotifications(toRoute.notificationContexts);
            }
        });
    }]);
